import React, { useEffect, useState } from "react";

import togImage from "../assets/w.jpg";
import oImage from "../assets/c.jpg";
import obImage from "../assets/47.jpg";
import heroImage from "../assets/21.jpg";
import heroImag from "../assets/ed.jpg";
import heroIma from "../assets/e.jpg";

const Education = () => {
  const [backgroundImage, setBackgroundImage] = useState(heroImage);
  const [isMobile, setIsMobile] = useState(false);
  const [activeCard, setActiveCard] = useState(null);

  const programs = [
    {
      title: "Workshops and Symposiums",
      description:
        "Regular training workshops and symposiums focusing on evidence-based nursing practices, new technologies, and specialized healthcare skills.",
      duration: "Varies by program",
      image: togImage,
      category: "Professional Development",
      credits: "5-15 CPD Credits",
      status: "Enrolling Now"
    },
    {
      title: "Continuing Professional Development (CPD)",
      description:
        "CPD programs help nurses enhance their skills, meet licensing requirements, and stay updated with modern medical advancements.",
      duration: "Year-round",
      image: oImage,
      category: "Certification",
      credits: "Annual Program",
      status: "Ongoing"
    },
    {
      title: "Research and Development Support",
      description:
        "Support for conducting research and publishing studies in healthcare innovations and nursing best practices.",
      duration: "On-demand",
      image: obImage,
      category: "Research",
      credits: "Flexible Schedule",
      status: "Apply Anytime"
    },
  ];

  const resources = [
    "Nursing Research Journals",
    "Training Manuals and Study Guides",
    "Webinars by International Experts",
    "Mentorship and Coaching Programs",
  ];

  const scholarshipInfo = {
    description:
      "The Lesotho Nursing and Midwifery Organisation offers scholarships to members pursuing higher education and specialized training programs. Scholarships are awarded based on academic merit, financial need, and commitment to professional growth.",
    applicationDeadline: "June 30, 2024",
    eligibility: [
      "Must be an active, registered member of the Lesotho Nursing and Midwifery Organization.",
      "Demonstrated academic excellence and professional dedication.",
      "Involvement in community health programs and volunteer activities.",
    ],
    benefits: [
      "Full tuition coverage for accredited programs",
      "Monthly stipend for educational materials",
      "Conference and workshop attendance support",
      "Research grant opportunities"
    ]
  };

  // Different overlay colors for each background image
  const getOverlayStyle = (image) => {
    const overlays = {
      [heroImage]: "linear-gradient(135deg, rgba(0, 82, 147, 0.85) 0%, rgba(0, 122, 221, 0.75) 100%)",
      [heroImag]: "linear-gradient(135deg, rgba(106, 27, 154, 0.85) 0%, rgba(156, 39, 176, 0.75) 100%)",
      [heroIma]: "linear-gradient(135deg, rgba(183, 28, 28, 0.85) 0%, rgba(229, 57, 53, 0.75) 100%)"
    };
    return overlays[image] || overlays[heroImage];
  };

  useEffect(() => {
    const interval = setInterval(() => {
      setBackgroundImage((prevImage) => {
        if (prevImage === heroImage) return heroImag;
        if (prevImage === heroImag) return heroIma;
        return heroImage;
      });
    }, 5000);

    const checkScreenSize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    checkScreenSize();
    window.addEventListener('resize', checkScreenSize);
    
    return () => {
      clearInterval(interval);
      window.removeEventListener('resize', checkScreenSize);
    };
  }, []);

  const handleApplyClick = () => {
    console.log("Scholarship application initiated");
    alert("Redirecting to scholarship application portal...");
  };

  const handleProgramClick = (programIndex) => {
    console.log("Program selected:", programs[programIndex].title);
    setActiveCard(programIndex);
  };

  return (
    <div style={styles.container}>
      {/* Hero Section with Enhanced Overlay */}
      <section
        style={{ 
          ...styles.heroSection, 
          backgroundImage: `${getOverlayStyle(backgroundImage)}, url(${backgroundImage})`,
          height: isMobile ? "50vh" : "65vh"
        }}
        aria-label="Education and Training Programs"
      >
        <div style={styles.heroOverlay}>
          <div style={styles.heroContent}>
            <div style={styles.heroBadge}>
              <span style={styles.badgeText}>Professional Development</span>
            </div>
            <h1 style={styles.header}>
              Education & Training
            </h1>
            <p style={styles.heroSubtext}>
              Empowering nurses through comprehensive knowledge, advanced skills, and cutting-edge research.
            </p>
            <div style={styles.heroActions}>
              <button style={styles.primaryButton}>
                Explore Programs
              </button>
              <button style={styles.secondaryButton}>
                Download Brochure
              </button>
            </div>
            <div style={styles.heroStats}>
              <div style={styles.statItem}>
                <div style={styles.statNumber}>500+</div>
                <div style={styles.statLabel}>Nurses Trained</div>
              </div>
              <div style={styles.statItem}>
                <div style={styles.statNumber}>98%</div>
                <div style={styles.statLabel}>Success Rate</div>
              </div>
              <div style={styles.statItem}>
                <div style={styles.statNumber}>50+</div>
                <div style={styles.statLabel}>Expert Facilitators</div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Educational Programs */}
      <section style={styles.section}>
        <div style={styles.sectionIntro}>
          <h2 style={styles.subHeader}>Our Educational Programs</h2>
          <p style={styles.sectionDescription}>
            Comprehensive training programs designed to enhance clinical skills, advance careers, 
            and improve patient care outcomes across Lesotho.
          </p>
        </div>
        
        <div style={{
          ...styles.cardContainer,
          flexDirection: isMobile ? "column" : "row"
        }}>
          {programs.map((program, index) => (
            <div 
              key={index} 
              style={{
                ...styles.card,
                width: isMobile ? "100%" : "calc(33.333% - 2rem)",
                transform: activeCard === index ? "translateY(-5px)" : "translateY(0)",
                borderLeft: `4px solid ${index === 0 ? '#0077B6' : index === 1 ? '#0096C7' : '#00B4D8'}`
              }}
              tabIndex={0}
              aria-label={`Program: ${program.title}`}
              onClick={() => handleProgramClick(index)}
              onMouseEnter={() => setActiveCard(index)}
              onMouseLeave={() => setActiveCard(null)}
            >
              <div style={styles.imageContainer}>
                <img 
                  src={program.image} 
                  alt={program.title} 
                  style={styles.cardImage} 
                />
                <div style={styles.imageOverlay}></div>
              </div>
              
              <div style={styles.cardContent}>
                <div style={styles.cardHeader}>
                  <span style={{
                    ...styles.programCategory,
                    backgroundColor: index === 0 ? '#0077B6' : index === 1 ? '#0096C7' : '#00B4D8'
                  }}>
                    {program.category}
                  </span>
                  <span style={styles.programStatus}>
                    {program.status}
                  </span>
                </div>
                
                <h3 style={styles.cardTitle}>{program.title}</h3>
                <p style={styles.cardDescription}>{program.description}</p>
                
                <div style={styles.programDetails}>
                  <div style={styles.detailRow}>
                    <span style={styles.detailLabel}>Duration:</span>
                    <span style={styles.detailValue}>{program.duration}</span>
                  </div>
                  <div style={styles.detailRow}>
                    <span style={styles.detailLabel}>Credits:</span>
                    <span style={styles.detailValue}>{program.credits}</span>
                  </div>
                </div>
                
                <button style={styles.cardButton}>
                  Register Now
                </button>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* Resources */}
      <section style={styles.section}>
        <div style={styles.sectionIntro}>
          <h2 style={styles.subHeader}>Educational Resources</h2>
          <p style={styles.sectionDescription}>
            Access our comprehensive library of learning materials, research tools, 
            and professional development resources.
          </p>
        </div>
        
        <div style={styles.resourcesContainer}>
          <div style={styles.resourceGrid}>
            {resources.map((resource, index) => (
              <div 
                key={index} 
                style={styles.resourceCard}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = "translateX(5px)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = "translateX(0)";
                }}
              >
                <div style={styles.resourceIcon}>
                  <div style={{
                    ...styles.iconCircle,
                    background: `linear-gradient(135deg, ${index === 0 ? '#0077B6' : index === 1 ? '#0096C7' : index === 2 ? '#00B4D8' : '#0077B6'}, ${index === 0 ? '#005B8C' : index === 1 ? '#0077A3' : index === 2 ? '#0096BA' : '#005B8C'})`
                  }}>
                    {index + 1}
                  </div>
                </div>
                <div style={styles.resourceContent}>
                  <h4 style={styles.resourceTitle}>{resource}</h4>
                  <p style={styles.resourceDesc}>
                    Access comprehensive materials and expert-led sessions to enhance your professional skills.
                  </p>
                  <button style={styles.resourceButton}>
                    Access Resource
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Scholarships */}
      <section style={styles.scholarshipSection}>
        <div style={styles.scholarshipContainer}>
          <div style={styles.scholarshipHeader}>
            <h2 style={styles.scholarshipTitle}>Scholarship Opportunities</h2>
            <div style={styles.deadlineBanner}>
              <span style={styles.deadlineText}>
                Application Deadline: {scholarshipInfo.applicationDeadline}
              </span>
            </div>
          </div>
          
          <div style={styles.scholarshipContent}>
            <div style={styles.scholarshipDescription}>
              <p>{scholarshipInfo.description}</p>
            </div>
            
            <div style={styles.scholarshipDetails}>
              <div style={styles.eligibilitySection}>
                <h3 style={styles.detailHeader}>Eligibility Criteria</h3>
                <ul style={styles.eligibilityList}>
                  {scholarshipInfo.eligibility.map((criteria, index) => (
                    <li key={index} style={styles.eligibilityItem}>
                      <span style={styles.bullet}></span>
                      {criteria}
                    </li>
                  ))}
                </ul>
              </div>
              
              <div style={styles.benefitsSection}>
                <h3 style={styles.detailHeader}>Scholarship Benefits</h3>
                <ul style={styles.benefitsList}>
                  {scholarshipInfo.benefits.map((benefit, index) => (
                    <li key={index} style={styles.benefitItem}>
                      <span style={styles.checkmark}>✓</span>
                      {benefit}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
            
            <div style={styles.scholarshipActions}>
              <button 
                style={styles.applyButton}
                onClick={handleApplyClick}
              >
                Apply for Scholarship
              </button>
              <button style={styles.infoButton}>
                Download Application Guidelines
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section style={styles.ctaSection}>
        <div style={styles.ctaBackground}>
          <div style={styles.ctaContent}>
            <h2 style={styles.ctaTitle}>Ready to Advance Your Career?</h2>
            <p style={styles.ctaDescription}>
              Join hundreds of nursing professionals who have transformed their careers through our education programs.
            </p>
            <div style={styles.ctaActions}>
              <button style={styles.ctaPrimary}>
                Contact Our Education Team
              </button>
              <button style={styles.ctaSecondary}>
                View Program Calendar
              </button>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

// Enhanced Styles with Better Image Handling
const styles = {
  container: {
    fontFamily: "'Inter', 'Segoe UI', system-ui, sans-serif",
    lineHeight: 1.6,
    backgroundColor: "#ffffff",
    minHeight: "100vh",
    color: "#2D3748",
  },
  heroSection: {
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundBlendMode: "multiply",
    position: "relative",
    transition: "all 1s ease-in-out",
  },
  heroOverlay: {
    backgroundColor: "rgba(0, 0, 0, 0.3)",
    width: "100%",
    height: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  heroContent: {
    maxWidth: "1200px",
    width: "100%",
    textAlign: "center",
    padding: "2rem",
  },
  heroBadge: {
    marginBottom: "1.5rem",
  },
  badgeText: {
    backgroundColor: "rgba(255, 255, 255, 0.25)",
    padding: "0.75rem 2rem",
    borderRadius: "50px",
    fontSize: "0.875rem",
    fontWeight: "600",
    letterSpacing: "0.5px",
    backdropFilter: "blur(10px)",
    border: "1px solid rgba(255, 255, 255, 0.2)",
    color: "#FFFFFF",
  },
  header: {
    fontSize: "clamp(2.5rem, 5vw, 4rem)",
    fontWeight: "800",
    marginBottom: "1.5rem",
    lineHeight: 1.1,
    textShadow: "0 4px 8px rgba(0,0,0,0.4)",
    color: "#FFFFFF",
  },
  heroSubtext: {
    fontSize: "clamp(1.125rem, 2.5vw, 1.5rem)",
    maxWidth: "800px",
    margin: "0 auto 2.5rem",
    opacity: 0.95,
    fontWeight: "400",
    color: "#F7FAFC",
    textShadow: "0 2px 4px rgba(0,0,0,0.3)",
  },
  heroActions: {
    display: "flex",
    gap: "1rem",
    justifyContent: "center",
    marginBottom: "3rem",
    flexWrap: "wrap",
  },
  primaryButton: {
    backgroundColor: "#FFFFFF",
    color: "#0077B6",
    padding: "1rem 2.5rem",
    border: "none",
    borderRadius: "8px",
    fontSize: "1.1rem",
    fontWeight: "600",
    cursor: "pointer",
    transition: "all 0.3s ease",
    boxShadow: "0 4px 15px rgba(0, 0, 0, 0.2)",
  },
  secondaryButton: {
    backgroundColor: "transparent",
    color: "#FFFFFF",
    padding: "1rem 2.5rem",
    border: "2px solid #FFFFFF",
    borderRadius: "8px",
    fontSize: "1.1rem",
    fontWeight: "600",
    cursor: "pointer",
    transition: "all 0.3s ease",
    backdropFilter: "blur(10px)",
  },
  heroStats: {
    display: "flex",
    justifyContent: "center",
    gap: "3rem",
    flexWrap: "wrap",
  },
  statItem: {
    textAlign: "center",
  },
  statNumber: {
    fontSize: "2.5rem",
    fontWeight: "800",
    marginBottom: "0.5rem",
    color: "#FFFFFF",
    textShadow: "0 2px 4px rgba(0,0,0,0.3)",
  },
  statLabel: {
    fontSize: "1rem",
    opacity: 0.9,
    fontWeight: "500",
    color: "#E2E8F0",
  },
  section: {
    padding: "5rem 2rem",
    maxWidth: "1200px",
    margin: "0 auto",
  },
  sectionIntro: {
    textAlign: "center",
    marginBottom: "3rem",
  },
  subHeader: {
    fontSize: "clamp(2rem, 4vw, 2.5rem)",
    color: "#1A365D",
    marginBottom: "1rem",
    fontWeight: "700",
  },
  sectionDescription: {
    fontSize: "1.125rem",
    color: "#718096",
    maxWidth: "800px",
    margin: "0 auto",
    lineHeight: 1.7,
  },
  cardContainer: {
    display: "flex",
    gap: "2rem",
    justifyContent: "center",
    alignItems: "stretch",
  },
  card: {
    backgroundColor: "#FFFFFF",
    borderRadius: "16px",
    boxShadow: "0 4px 25px rgba(0, 0, 0, 0.08)",
    overflow: "hidden",
    transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
    cursor: "pointer",
    display: "flex",
    flexDirection: "column",
  },
  imageContainer: {
    position: "relative",
    overflow: "hidden",
  },
  cardImage: {
    width: "100%",
    height: "200px",
    objectFit: "cover",
    transition: "transform 0.3s ease",
  },
  imageOverlay: {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    background: "linear-gradient(to bottom, rgba(0,0,0,0.1) 0%, rgba(0,0,0,0.3) 100%)",
    opacity: 0.6,
  },
  cardContent: {
    padding: "2rem",
    flex: 1,
    display: "flex",
    flexDirection: "column",
  },
  cardHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "1rem",
  },
  programCategory: {
    padding: "0.5rem 1rem",
    borderRadius: "20px",
    fontSize: "0.75rem",
    fontWeight: "700",
    color: "#FFFFFF",
    letterSpacing: "0.5px",
  },
  programStatus: {
    fontSize: "0.75rem",
    color: "#48BB78",
    fontWeight: "700",
    backgroundColor: "#F0FFF4",
    padding: "0.25rem 0.75rem",
    borderRadius: "12px",
  },
  cardTitle: {
    fontSize: "1.375rem",
    fontWeight: "700",
    color: "#2D3748",
    marginBottom: "1rem",
    lineHeight: 1.4,
  },
  cardDescription: {
    color: "#718096",
    marginBottom: "1.5rem",
    flex: 1,
    lineHeight: 1.6,
    fontSize: "0.95rem",
  },
  programDetails: {
    marginBottom: "1.5rem",
    backgroundColor: "#F8FAFC",
    padding: "1rem",
    borderRadius: "8px",
  },
  detailRow: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "0.5rem 0",
    borderBottom: "1px solid #E2E8F0",
  },
  detailRow: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "0.5rem 0",
    borderBottom: "1px solid #E2E8F0",
  },
  detailLabel: {
    fontWeight: "600",
    color: "#4A5568",
    fontSize: "0.875rem",
  },
  detailValue: {
    color: "#718096",
    fontWeight: "500",
    fontSize: "0.875rem",
  },
  cardButton: {
    background: "linear-gradient(135deg, #0077B6 0%, #005B8C 100%)",
    color: "#FFFFFF",
    padding: "0.875rem 1.5rem",
    border: "none",
    borderRadius: "8px",
    fontSize: "0.95rem",
    fontWeight: "600",
    cursor: "pointer",
    transition: "all 0.3s ease",
    textAlign: "center",
    width: "100%",
  },
  resourcesContainer: {
    maxWidth: "1000px",
    margin: "0 auto",
  },
  resourceGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))",
    gap: "1.5rem",
  },
  resourceCard: {
    backgroundColor: "#F8FAFC",
    padding: "2rem",
    borderRadius: "12px",
    border: "1px solid #E2E8F0",
    transition: "all 0.3s ease",
    display: "flex",
    alignItems: "flex-start",
    gap: "1.5rem",
  },
  resourceIcon: {
    flexShrink: 0,
  },
  iconCircle: {
    width: "50px",
    height: "50px",
    color: "#FFFFFF",
    borderRadius: "12px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontWeight: "700",
    fontSize: "1rem",
    boxShadow: "0 4px 12px rgba(0, 119, 182, 0.3)",
  },
  resourceContent: {
    flex: 1,
  },
  resourceTitle: {
    fontSize: "1.25rem",
    fontWeight: "600",
    color: "#2D3748",
    marginBottom: "0.75rem",
  },
  resourceDesc: {
    color: "#718096",
    fontSize: "0.95rem",
    marginBottom: "1.5rem",
    lineHeight: 1.5,
  },
  resourceButton: {
    backgroundColor: "transparent",
    color: "#0077B6",
    border: "1px solid #0077B6",
    padding: "0.75rem 1.5rem",
    borderRadius: "6px",
    fontSize: "0.875rem",
    fontWeight: "600",
    cursor: "pointer",
    transition: "all 0.3s ease",
  },
  scholarshipSection: {
    backgroundColor: "#F7FAFC",
    padding: "5rem 2rem",
  },
  scholarshipContainer: {
    maxWidth: "1200px",
    margin: "0 auto",
    backgroundColor: "#FFFFFF",
    borderRadius: "20px",
    boxShadow: "0 8px 40px rgba(0, 0, 0, 0.08)",
    overflow: "hidden",
  },
  scholarshipHeader: {
    background: "linear-gradient(135deg, #1A365D 0%, #2D3748 100%)",
    color: "#FFFFFF",
    padding: "3rem 2rem",
    textAlign: "center",
  },
  scholarshipTitle: {
    fontSize: "2.25rem",
    fontWeight: "700",
    marginBottom: "1.5rem",
  },
  deadlineBanner: {
    backgroundColor: "#E53E3E",
    padding: "1rem 2rem",
    borderRadius: "8px",
    display: "inline-block",
    boxShadow: "0 4px 12px rgba(229, 62, 62, 0.3)",
  },
  deadlineText: {
    fontWeight: "700",
    fontSize: "1rem",
  },
  scholarshipContent: {
    padding: "3rem",
  },
  scholarshipDescription: {
    fontSize: "1.125rem",
    color: "#4A5568",
    marginBottom: "2.5rem",
    lineHeight: 1.7,
    textAlign: "center",
  },
  scholarshipDetails: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))",
    gap: "3rem",
    marginBottom: "3rem",
  },
  eligibilitySection: {
    flex: 1,
  },
  benefitsSection: {
    flex: 1,
  },
  detailHeader: {
    fontSize: "1.375rem",
    fontWeight: "600",
    color: "#2D3748",
    marginBottom: "1.5rem",
    paddingBottom: "0.5rem",
    borderBottom: "2px solid #E2E8F0",
  },
  eligibilityList: {
    listStyle: "none",
    padding: 0,
  },
  eligibilityItem: {
    display: "flex",
    alignItems: "flex-start",
    marginBottom: "1rem",
    color: "#4A5568",
    lineHeight: 1.5,
    fontSize: "1rem",
  },
  bullet: {
    width: "8px",
    height: "8px",
    backgroundColor: "#0077B6",
    borderRadius: "50%",
    marginRight: "1rem",
    marginTop: "0.5rem",
    flexShrink: 0,
  },
  benefitsList: {
    listStyle: "none",
    padding: 0,
  },
  benefitItem: {
    display: "flex",
    alignItems: "center",
    marginBottom: "1rem",
    color: "#2D3748",
    fontWeight: "500",
    fontSize: "1rem",
  },
  checkmark: {
    color: "#48BB78",
    marginRight: "1rem",
    fontWeight: "700",
    fontSize: "1.1rem",
  },
  scholarshipActions: {
    display: "flex",
    gap: "1.5rem",
    justifyContent: "center",
    flexWrap: "wrap",
  },
  applyButton: {
    background: "linear-gradient(135deg, #0077B6 0%, #005B8C 100%)",
    color: "#FFFFFF",
    padding: "1.25rem 2.5rem",
    border: "none",
    borderRadius: "8px",
    fontSize: "1.1rem",
    fontWeight: "600",
    cursor: "pointer",
    transition: "all 0.3s ease",
    boxShadow: "0 4px 15px rgba(0, 119, 182, 0.3)",
  },
  infoButton: {
    backgroundColor: "transparent",
    color: "#0077B6",
    padding: "1.25rem 2.5rem",
    border: "2px solid #0077B6",
    borderRadius: "8px",
    fontSize: "1.1rem",
    fontWeight: "600",
    cursor: "pointer",
    transition: "all 0.3s ease",
  },
  ctaSection: {
    padding: "5rem 2rem",
  },
  ctaBackground: {
    background: "linear-gradient(135deg, #1A365D 0%, #2D3748 100%)",
    borderRadius: "20px",
    padding: "4rem 2rem",
    textAlign: "center",
  },
  ctaContent: {
    maxWidth: "800px",
    margin: "0 auto",
  },
  ctaTitle: {
    fontSize: "2.5rem",
    fontWeight: "700",
    marginBottom: "1.5rem",
    color: "#FFFFFF",
  },
  ctaDescription: {
    fontSize: "1.25rem",
    opacity: 0.9,
    marginBottom: "2.5rem",
    color: "#E2E8F0",
  },
  ctaActions: {
    display: "flex",
    gap: "1.5rem",
    justifyContent: "center",
    flexWrap: "wrap",
  },
  ctaPrimary: {
    backgroundColor: "#FFFFFF",
    color: "#1A365D",
    padding: "1.25rem 2.5rem",
    border: "none",
    borderRadius: "8px",
    fontSize: "1.1rem",
    fontWeight: "600",
    cursor: "pointer",
    transition: "all 0.3s ease",
    boxShadow: "0 4px 15px rgba(255, 255, 255, 0.2)",
  },
  ctaSecondary: {
    backgroundColor: "transparent",
    color: "#FFFFFF",
    padding: "1.25rem 2.5rem",
    border: "2px solid #FFFFFF",
    borderRadius: "8px",
    fontSize: "1.1rem",
    fontWeight: "600",
    cursor: "pointer",
    transition: "all 0.3s ease",
  },
};

// Enhanced hover effects
const addHoverEffects = () => {
  const style = document.createElement('style');
  style.textContent = `
    button:hover {
      transform: translateY(-2px);
      box-shadow: 0 6px 20px rgba(0, 0, 0, 0.15);
    }
    
    .card:hover {
      transform: translateY(-8px);
      box-shadow: 0 12px 40px rgba(0, 0, 0, 0.15);
    }
    
    .card:hover .cardImage {
      transform: scale(1.05);
    }
    
    .resource-card:hover {
      background-color: #FFFFFF;
      border-color: #0077B6;
      transform: translateY(-2px);
      box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1);
    }
  `;
  document.head.appendChild(style);
};

if (typeof document !== 'undefined') {
  addHoverEffects();
}

export default Education;